

export function formatMoney(amount) {
    if (isNaN(Number(amount))) {
        return amount;
    }
    return '￥' +Number(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export function formatWan(amount) {
    if (isNaN(Number(amount))) {
        return amount;
    }
    // 返回万元

    if (amount >= 10000){
        return '￥' +Number(amount / 10000).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + '万';

    }
    if (amount <= -10000){
        return '￥' +Number(amount / 10000).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,') + '万';
    }
    return '￥' +Number(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}